import axios from 'axios'

export default ({
    namespaced: true,
    state: {
        accountStatus: null,
    },

    getters:{
        accountStatus(state){
            return state.accountStatus
        },
    },

    mutations: {
        SET_ACCOUNT_STATUS(state, data) {
            state.accountStatus = data
        },
    },

    actions: {
        async getAccountStatus({commit}) {
        // async getAccountStatus({commit,dispatch}, page) {
            try {
                // page = page ? page : 0
                let response = await axios.get('account-status')
                commit('SET_ACCOUNT_STATUS', response.data)

            } catch (e) {
                // dispatch('auth/setAuthErrors', e.response )
                throw Error;
            }
        },
    }
})
